var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLubavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H8.92V16H27C27 23.1791 20.9574 29 13.5013 29C6.04526 29 0 23.1791 0 16H8.92C8.92 18.4347 10.9701 20.4083 13.5015 20.4083C16.0301 20.4083 18.0799 18.4347 18.0799 16H0V0Z",
    fill: "#367FFF",
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M11 15.5C11 16.8807 12.1193 18 13.5 18C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13C12.1193 13 11 14.1193 11 15.5Z",
    fill: "#FF5B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubavLogo);
export default __webpack_public_path__ + "static/media/lubav-logo.f4f0d9b2bec071a2dc851d9d6a33420f.svg";
export { ForwardRef as ReactComponent };